/* OM Boots Ultra Launch LP – v5 (Capture + Consent-Fehler-Reset bei Checkbox-Change) */
(function () {
  'use strict';

  (function injectCss() {
    if (document.getElementById('lpConsentCss')) return;
    var s = document.createElement('style');
    s.id = 'lpConsentCss';
    s.textContent = '.om-lpw1 .lp-consent input,.om-lpw2 .lp-consent input{width:19px;height:19px;flex:0 0 19px;margin-top:1px;accent-color:#86a800;cursor:pointer;}';
    (document.head || document.documentElement).appendChild(s);
  })();

  function cfg(name, fallback) {
    var el = document.getElementById('lpConfig');
    var v = el ? el.getAttribute('data-' + name) : null;
    return (v === null || v === '') ? (fallback || '') : v;
  }

  function closeModal() {
    var m = document.getElementById('lpModal'), v = document.getElementById('lpModalVideo');
    if (m) { m.hidden = true; }
    if (v) { try { v.pause(); } catch (err) {} }
  }

  function openModal() {
    var m = document.getElementById('lpModal'), v = document.getElementById('lpModalVideo');
    if (!m) return;
    m.hidden = false;
    if (v) { if (!v.getAttribute('src')) v.src = v.getAttribute('data-src') || cfg('video', ''); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }

  function subscribe(email, code, btn, errEl, onDone) {
    btn.disabled = true; btn.textContent = 'Wird eingetragen …';
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg('company', 'VXahFi')), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2025-01-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Boots Ultra Launch LP', profile: { data: { type: 'profile', attributes: { email: email, properties: { raa_code: code || 'ohne Code' } } } } }, relationships: { list: { data: { type: 'list', id: cfg('list', 'RbRKYd') } } } } })
    }).then(function (r) {
      if (r.status === 202) { onDone(); }
      else { if (errEl) { errEl.textContent = 'Das hat leider nicht geklappt. Bitte prüfe die E-Mail-Adresse und versuche es erneut.'; errEl.hidden = false; } btn.disabled = false; btn.textContent = 'Eintragen →'; }
    }).catch(function () {
      if (errEl) { errEl.textContent = 'Verbindungsfehler – bitte versuche es erneut.'; errEl.hidden = false; }
      btn.disabled = false; btn.textContent = 'Eintragen →';
    });
  }

  function toMail(card, ok) {
    var stepCode = card.querySelector('.lp-step-code'), stepMail = card.querySelector('.lp-step-mail');
    if (stepCode) stepCode.hidden = true;
    if (stepMail) { stepMail.hidden = false; var okEl = stepMail.querySelector('.lp-ok'); if (okEl) okEl.hidden = !ok; }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeModal();
  });

  document.addEventListener('click', function (e) {
    if (e.__omLpHandled) return;
    e.__omLpHandled = true;
    var t = e.target;
    if (!t || !t.closest) return;

    // Modal offen? Alles außerhalb des Video-Frames schließt.
    var modalEl = document.getElementById('lpModal');
    if (modalEl && !modalEl.hidden && t.closest('#lpModal')) {
      if (!t.closest('.lp-modal-frame')) { closeModal(); }
      return;
    }

    if (t.closest('#lpVideoOpen') || t.closest('#lpVideoOpen2')) { openModal(); return; }

    if (t.closest('#lpStickyBtn')) {
      var target = document.getElementById('lpCardBottom') || document.getElementById('lpCardTop');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    var unlock = t.closest('.lp-unlock');
    if (unlock) {
      var card = unlock.closest('.lp-card'); if (!card) return;
      var input = card.querySelector('.lp-code');
      var err = card.querySelector('.lp-step-code .lp-err');
      var v = ((input && input.value) || '').trim().toUpperCase();
      var valid = cfg('code', 'Weltmeisterschaft').toUpperCase();
      if (v !== '' && v === valid) { card.setAttribute('data-code', v); if (err) err.hidden = true; toMail(card, true); }
      else if (err) { err.hidden = false; }
      return;
    }

    var nocode = t.closest('.lp-nocode');
    if (nocode) {
      var c2 = nocode.closest('.lp-card'); if (!c2) return;
      c2.setAttribute('data-code', '');
      toMail(c2, false);
      return;
    }

    var submit = t.closest('.lp-submit');
    if (submit) {
      var c3 = submit.closest('.lp-card'); if (!c3) return;
      var emailEl = c3.querySelector('.lp-email');
      var email = ((emailEl && emailEl.value) || '').trim();
      var consent = c3.querySelector('.lp-check');
      var errs = c3.querySelectorAll('.lp-step-mail .lp-err');
      var err3 = errs.length ? errs[errs.length - 1] : null;
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { if (err3) { err3.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.'; err3.hidden = false; } return; }
      if (!consent || !consent.checked) { if (err3) { err3.textContent = 'Bitte bestätige die Einwilligung, damit wir dich benachrichtigen dürfen.'; err3.hidden = false; } return; }
      subscribe(email, c3.getAttribute('data-code') || '', submit, err3, function () {
        var stepMail = c3.querySelector('.lp-step-mail'), stepDone = c3.querySelector('.lp-step-done');
        if (stepMail) stepMail.hidden = true;
        if (stepDone) stepDone.hidden = false;
      });
      return;
    }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('lp-check') && t.checked) {
      var card = t.closest ? t.closest('.lp-card') : null;
      if (card) {
        var errs = card.querySelectorAll('.lp-step-mail .lp-err');
        var er = errs.length ? errs[errs.length - 1] : null;
        if (er) er.hidden = true;
      }
    }
  }, true);

  window.addEventListener('scroll', function () {
    var sticky = document.getElementById('lpSticky'), card = document.getElementById('lpCardTop');
    if (!sticky || !card) return;
    var r = card.getBoundingClientRect();
    var pastCard = r.bottom < 0;
    var bottomCard = document.getElementById('lpCardBottom');
    var nearBottom = bottomCard ? bottomCard.getBoundingClientRect().top < window.innerHeight : false;
    sticky.classList.toggle('show', pastCard && !nearBottom);
  }, { passive: true });

  function initDots() {
    var track = document.getElementById('lpTrack'), dotsWrap = document.getElementById('lpDots');
    if (!track || !dotsWrap || dotsWrap.children.length) return;
    var slides = track.children.length, dots = [];
    for (var i = 0; i < slides; i++) { var d = document.createElement('span'); if (i === 0) d.className = 'on'; dotsWrap.appendChild(d); dots.push(d); }
    track.addEventListener('scroll', function () {
      var idx = Math.round(track.scrollLeft / (track.scrollWidth / slides));
      dots.forEach(function (d, i) { d.classList.toggle('on', i === Math.min(idx, slides - 1)); });
    }, { passive: true });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initDots); }
  else { initDots(); }
})();
